import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ManualAddressEntry } from '@components/AddressCapture/ManualAddressEntry';
import type { ManualAddressEntryProps } from '@components/AddressCapture/ManualAddressEntry';

/**
 * What the customer sees when the vendor lookup will not answer — because the
 * daily cap tripped, the per-IP limit tripped, or no key reached this
 * environment.
 *
 * The copy says the lookup is unavailable and never that the address is
 * unserviceable: those are different facts, and conflating them abandons a
 * purchase Novus could have fulfilled.
 */
const ManualAddressFallback = ({ onSubmit, isSubmitting }: ManualAddressEntryProps) => (
  <Stack gap="15px">
    <Alert severity="info" icon={false} className="check-availability-inline-alert">
      <Typography component="p" variant="body.md" sx={{ color: 'border.black', lineHeight: '130%' }}>
        Address lookup is temporarily unavailable. Please enter your address below and we will check availability
        for you.
      </Typography>
    </Alert>
    <ManualAddressEntry onSubmit={onSubmit} isSubmitting={isSubmitting} />
  </Stack>
);

export default ManualAddressFallback;
